function initializeQuiz(retryCount = 0) {
  const maxRetries = 5;
  const retryDelay = 1000; // 1 second
 const API_URL = 'https://goodcausewins-530649d4483e.herokuapp.com/api/get-recommendations';

  // Try to get all required elements
  const elements = {
    form: document.getElementById("sweepstakes-quiz-form"),
    submitBtn: document.getElementById("submitQuiz"),
    productGrid: document.querySelector("#quiz-results .sweeps-grid"),
    errorMessage: document.getElementById("error-message"),
    statusMessage: document.getElementById("quiz-status"),
    category: document.getElementById("category"),
    value: document.getElementById("value"),
    frequency: document.getElementById("frequency"),
    cause: document.getElementById("cause")
  };

  // Check if all required elements are present
  const missingElements = Object.entries(elements)
    .filter(([key, element]) => !element)
    .map(([key]) => key);

  if (missingElements.length > 0) {
    console.log(`Missing elements: ${missingElements.join(', ')}. Retry ${retryCount + 1}/${maxRetries}`);
    
    if (retryCount < maxRetries) {
      setTimeout(() => initializeQuiz(retryCount + 1), retryDelay);
      return;
    }
    
    console.error("Failed to initialize quiz after maximum retries. Missing elements:", missingElements);
    return;
  }

  function showError(message, isTemporary = false) {
    console.error('Quiz Error:', message);
    if (elements.errorMessage) {
      elements.errorMessage.style.display = "block";
      elements.errorMessage.textContent = message;
      if (isTemporary) {
        setTimeout(() => {
          elements.errorMessage.style.display = "none";
        }, 5000);
      }
    }
  }

  function showStatus(message) {
    if (elements.statusMessage) {
      elements.statusMessage.style.display = "block";
      elements.statusMessage.textContent = message;
    }
  }

  function hideMessages() {
    if (elements.errorMessage) {
      elements.errorMessage.style.display = "none";
      elements.errorMessage.textContent = '';
    }
    if (elements.statusMessage) {
      elements.statusMessage.style.display = "none";
      elements.statusMessage.textContent = '';
    }
  }

  function showLoading() {
    showStatus('🔍 Finding your perfect sweepstakes...');
    elements.submitBtn.disabled = true;
  }

  function hideLoading() {
    elements.submitBtn.disabled = false;
  }

  function clearResults() {
    if (elements.productGrid) {
      elements.productGrid.innerHTML = '';
    }
  }

  // Add submit handler to form
  elements.form.addEventListener("submit", async (e) => {
    e.preventDefault();
    console.log('Quiz submission started');

    try {
      hideMessages();
      showLoading();
      clearResults();

      // Map the user's selected category to what the server expects
      const categoryMap = {
        "Cars & Vehicles": "Cars",
        "Motorcycles": "Cars",
        "Travel & Vacations": "Travel",
        "Cash & Money": "Cash",
        "Electronics & Gadgets": "Electronics",
        "Shopping Spree": "Shopping",
        "Home & Garden": "Home & Lifestyle",
        "Sports & Recreation": "Outdoor & Adventure",
        "Fashion & Accessories": "Shopping",
        "Entertainment": "Electronics",
        "Food & Dining": "Shopping",
        "VIP Experiences": "Travel"
      };

      const selectedCategory = elements.category.value;
      const selectedValue = elements.value.value;

      const mappedCategory = selectedCategory === "Any Category" ? null : categoryMap[selectedCategory];
      const mappedValue = selectedValue === "Any Prize Value" ? null : selectedValue;

      console.log('Selected values:', {
        category: selectedCategory,
        value: selectedValue,
        frequency: elements.frequency.value,
        cause: elements.cause.value
      });
      
      console.log('Mapped values:', {
        category: mappedCategory,
        value: mappedValue
      });

      const requestData = {
        category: mappedCategory,
        value: mappedValue,
        frequency: elements.frequency.value === "Any Frequency" ? null : elements.frequency.value,
        cause: elements.cause.value === "Any Cause" ? null : elements.cause.value
      };

      const response = await fetch(API_URL, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(requestData)
      });

      const responseText = await response.text();
      let data;
      try {
        data = JSON.parse(responseText);

        if (!data || !Array.isArray(data.recommendations)) {
          console.error('Invalid response format:', data);
          showError('Received invalid response format from server');
          hideLoading();
          return;
        }

        if (data.recommendations.length === 0) {
          console.log('No recommendations found');
          showStatus('No sweepstakes found for your preferences. Try different options!');
          hideLoading();
          return;
        }

        // Update the results grid with new recommendations
        elements.productGrid.innerHTML = data.recommendations.map((sweep) => `
          <li>
            <article class="sweep-card">
              <div class="sweep-image">
                <img
                  src="${sweep.image || 'https://via.placeholder.com/400x400'}"
                  alt="${sweep.title}"
                  loading="lazy"
                >
              </div>
              <div class="sweep-content">
                <h3 class="sweep-title">
                  <a href="${sweep.url}">${sweep.title}</a>
                </h3>
                <div class="sweep-button">
                  <a href="${sweep.url}" class="button">Learn More</a>
                </div>
              </div>
            </article>
          </li>
        `).join('');

        hideLoading();
        showStatus(`Found ${data.recommendations.length} matching sweepstakes!`);

      } catch (parseError) {
        console.error('Failed to parse response:', parseError);
        showError('Error processing server response. Please try again later.');
        hideLoading();
      }
    } catch (err) {
      console.error('Quiz error:', err);
      showError('Error fetching recommendations. Please try again later.');
      hideLoading();
    }
  });
}

// Initialize the quiz when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(initializeQuiz, 500));
} else {
  setTimeout(initializeQuiz, 500);
}
